// extracted by mini-css-extract-plugin
export default {"playground":"Playground_playground__BB4wc","workplace":"Playground_workplace__ccL2u"};